'use client';
import React from 'react';
import './HandChange.css';
import { observer } from 'mobx-react';
import { IconButton } from './ui/button';
import { useManagerEntity } from '@/shared/managerHelpers';
import { SELECTED_HAND } from '@/sharedTypes/coreTypes';
import { useAsyncManagerState } from '@/hooks/useAsyncManagerState';

export const HandChange = observer(() => {
  const [selectedHand, setSelectedHand, loading] =
    useAsyncManagerState('selectedHand');

  const managerEntity = useManagerEntity();
  const switchToRightHand = () => {
    if (managerEntity) {
      if (selectedHand === SELECTED_HAND.RIGHT) {
        setSelectedHand(-1);
      } else {
        setSelectedHand(0);
      }
    }
  };

  const switchToLeftHand = () => {
    if (managerEntity) {
      if (selectedHand === SELECTED_HAND.LEFT) {
        setSelectedHand(-1);
      } else {
        setSelectedHand(1);
      }
    }
  };

  if (loading) {
    return null;
  }

  return (
    <div
      className='rounded-md ml-1 p-1 border flex items-center flex-none'
      id='hand_change'
    >
      <IconButton
        onClick={switchToLeftHand}
        iconName='HandLeft'
        data-testid='hand_change_left_btn'
        noPadding
        noHover
        classNameIcon={`w-[34px] h-[34px] fill-black md:hover:fill-accent-blue ${
          selectedHand === SELECTED_HAND.LEFT && 'fill-accent-blue'
        }`}
      />
      <IconButton
        onClick={switchToRightHand}
        iconName='HandRight'
        data-testid='hand_change_right_btn'
        noPadding
        noHover
        classNameIcon={`w-[34px] h-[34px] fill-black md:hover:fill-accent-blue ${
          selectedHand === SELECTED_HAND.RIGHT && 'fill-accent-blue'
        }`}
      />
    </div>
  );
});
